function formatAmount(amount) {
  // Convert to a number
  const number = parseFloat(amount);

  // Check if it's a valid number
  if (isNaN(number)) {
    return "Invalid amount";
  }

  // Format with commas and 2 decimal places
  return number.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
export default formatAmount;
